import React, {useState} from 'react'
import InfoIcon from '@mui/icons-material/Info';
import zIndex from '@mui/material/styles/zIndex';


interface Props {
    text: string
    title: string
}

const AlarmInfoIconAndTitle: React.FC<Props> = ({text, title }) => {

    const [showPopup, setShowPopup] = useState<boolean>(false)


    const overViewStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 10px 0 10px",
        boxShadow: "2px 2px 10px #00000060",
        borderLeft: '6px solid #00bf00',
        zIndex: 1000000000000
    }

    return (
        <div style={{ display: 'flex' }}>
            <p><b>{title}</b></p>
            <div style={{position: 'relative'} }>
                <InfoIcon
                    style={{ color: 'black', margin: '-5px 0 0 10px' }}
                    fontSize='small'
                    onMouseEnter={(): void => setShowPopup(true)}
                    onMouseLeave={(): void => setShowPopup(false)}
                />
                {showPopup && <div
                    style={{
                        ...overViewStyle,
                        position: 'absolute',
                        width: '400px',
                        top: -20,
                        left: 35,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                    <p>{text}</p>
                </div>}
            </div>
        </div>
    )
}
export default AlarmInfoIconAndTitle